var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.initialized)?_c('BaseVCalendar',{ref:"calendar",attrs:{"query":_vm.query,"editorComponent":_vm.editorComponent,"formular":_vm.formular,"dsHeight":450,"druckItems":_vm.druckItems}}):_c('span',[_vm._v("missing data :(")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }